import { Clock, DollarSign, Briefcase, TrendingUp, AlertTriangle } from "lucide-react";

export function StatCard({ label, value, subValue, icon: Icon, highlight, warning }) {
  return (
    <div className={`rounded-xl border p-4 ${warning ? 'bg-red-50 border-red-200' : highlight ? 'bg-primary/5 border-primary/20' : 'bg-card'}`}>
      <div className="flex items-center gap-2 mb-1">
        <Icon className={`w-4 h-4 ${warning ? 'text-red-500' : 'text-muted-foreground'}`} />
        <span className={`text-xs font-medium ${warning ? 'text-red-600' : 'text-muted-foreground'}`}>{label}</span>
      </div>
      <p className={`text-2xl font-light ${warning ? 'text-red-700' : ''}`}>{value}</p>
      {subValue && <p className={`text-xs mt-0.5 ${warning ? 'text-red-500' : 'text-muted-foreground'}`}>{subValue}</p>}
    </div>
  );
}

export function WorkloadStats({ summary, canSeeCosts }) {
  const isOverAllocated = summary.is_over_allocated;
  
  return (
    <div className="space-y-3">
      {/* Over-allocation warning banner */}
      {isOverAllocated && (
        <div className="flex items-center gap-2 p-3 rounded-lg bg-red-50 border border-red-200 text-red-700">
          <AlertTriangle className="w-5 h-5 flex-shrink-0" />
          <div>
            <p className="font-medium text-sm">Over-allocated by {summary.over_allocation_hours}h</p>
            <p className="text-xs text-red-600">
              Capacity: {summary.capacity_hours}h ({summary.hours_per_day}h/day × {summary.period_days} day{summary.period_days !== 1 ? 's' : ''})
            </p>
          </div>
        </div>
      )}
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <StatCard 
          label="Allocated Hours" 
          value={`${summary.total_hours}h`}
          subValue={`Capacity: ${summary.capacity_hours || summary.total_hours}h`}
          icon={Clock}
          highlight={!isOverAllocated}
          warning={isOverAllocated}
        />
        {canSeeCosts && (
          <StatCard 
            label="Total Cost" 
            value={`$${summary.total_cost?.toLocaleString() || 0}`}
            subValue={summary.hourly_rate ? `@ $${summary.hourly_rate}/hr` : null}
            icon={DollarSign}
          />
        )}
        <StatCard 
          label="Projects" 
          value={summary.projects_count}
          icon={Briefcase}
        />
        <StatCard 
          label="Avg Hours/Project" 
          value={summary.projects_count > 0 
            ? `${(summary.total_hours / summary.projects_count).toFixed(1)}h`
            : "0h"
          }
          icon={TrendingUp}
        />
      </div>
    </div>
  );
}
